import {
  GET_SUB_CATEGORY_RESOLUTIONS,
  GET_SUB_CATEGORY_RESOLUTIONS_SUCCESS,
  GET_SUB_CATEGORY_RESOLUTIONS_ERROR,
  GET_SUB_CATEGORY_RESOLUTIONS_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetSubCategoryResolutions = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUB_CATEGORY_RESOLUTIONS:
      return { ...state, loading: true, success: false, error: false, message: null };

    case GET_SUB_CATEGORY_RESOLUTIONS_SUCCESS:
      return { ...state, data: action.payload, loading: false, success: true, error: false };

    case GET_SUB_CATEGORY_RESOLUTIONS_ERROR:
      return { ...state, data: null, loading: false, success: false, error: true, message: action.payload };

    case GET_SUB_CATEGORY_RESOLUTIONS_EMPTY:
      return { ...initialState };

    default:
      return state;
  }
};

export default GetSubCategoryResolutions;
